/* eslint-disable no-nested-ternary */
import React from 'react';
import s from './StaticContent.scss';
import ImageV2 from '../ImageV2';
import {
  IMAGE_URL,
  IMAGE_VERSION,
  TOI_IMAGE_DOMAIN,
} from '../../../constants/index';

class StaticContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { sectionItem } = this.props;
    const isAboutSection = sectionItem?.id === 'static_online_school_about';
    const isParentologyPage = sectionItem?.id === 'static_pareting_about';
    const fincialComp = (
      <div className={s.aboutWrap}>
        <div className={s.aboutContent}>
          <div className={s.topHead}>
            <figure className={s.toiLogo}>
              <img src={`${TOI_IMAGE_DOMAIN}/photo/108295006.cms`} alt="" />
            </figure>
            <figure className={s.finacialLogo}>
              <img src={`${TOI_IMAGE_DOMAIN}/photo/108295010.cms`} alt="" />
            </figure>
          </div>
          <div className={s.webContent}>
            <h1>
              Indiaâ€™s Journey to
              <span> Financial Independence </span>
              Starts Today!
            </h1>
            <div className={s.litracyLogo}>
              <figure>
                <img src={`${TOI_IMAGE_DOMAIN}/photo/108295009.cms`} alt="" />
              </figure>
            </div>
            <div className={s.description}>
              <p>
                The revolution to a financial literate India is going to bring
                another shade of independence to the country. Empowering and
                transforming the life of millions with knowledge, skills,
                technology and resources from financial luminaries. The
                <strong> The Times of India </strong> and
                <strong> StockGro </strong> have joined hands for this epic in
                initiative, which will bridge the great divide in our society
              </p>
            </div>
          </div>
        </div>
      </div>
    );

    const parentingComp = (
      <div className={s.aboutPageWrapper}>
        <div className={s.bgWrap}>
          <div className={s.topHeader}>
            <div className={s.graphicBg}>
              <span>
                Learn to
                <strong> Re-Access </strong>
                Your Parenting Journey.
              </span>
            </div>
          </div>
          <div className={s.midContent}>
            <div className={s.leftArea}>
              <div className={s.logo}>
                <img
                  src={`${TOI_IMAGE_DOMAIN}/photo/125737278.cms`}
                  alt="orchid  international school"
                />
              </div>
              <span className={s.presents}>Presents</span>
              <h1>
                <span>PARENTOLOGY</span>
              </h1>
              <div className={s.subheading}>
                <span>THE SCIENCE OF PARENTING</span>
              </div>
              <div className={s.supportedBy}>
                <span>Supported by</span>{' '}
                <figure className={s.toiLogo}>
                  <img
                    src={`${TOI_IMAGE_DOMAIN}/photo/122386556.cms`}
                    alt="TOI Logo"
                  />
                </figure>
              </div>
            </div>

            <div className={s.rightArea}>
              <figure>
                <img
                  src={`${TOI_IMAGE_DOMAIN}/photo/125737269.cms`}
                  alt="Mother and Child"
                />
              </figure>
            </div>
          </div>
        </div>
        <div className={s.bottomContent}>
          <div className={s.keyPoints}>
            <h2>
              Key Aspects of <strong>Parentology</strong>
            </h2>

            <ul className={s.keyPointsList}>
              <li>
                <span>Encourage Reflection on Parenting Style</span>
              </li>
              <li>
                <span>Highlight Support and Resources Challenges</span>
              </li>
              <li>
                <span>Focus on Children's Perspectives</span>
              </li>
              <li>
                <span>Promote Mindful Parenting</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
    return (
      <>
        {isAboutSection ? (
          <div className={s.onlineschoolPage}>
            <ImageV2
              src={`${IMAGE_URL}msid-${
                sectionItem.msid ? sectionItem.msid : '69347424'
              },imgsize-${IMAGE_VERSION?.version}.cms`}
            />
          </div>
        ) : (
          <div className={s.aboutPage}>
            {isParentologyPage ? parentingComp : fincialComp}
          </div>
        )}
      </>
    );
  }
}

export default StaticContent;
